import type { ScriptData } from '@/components/platform/types'

/** Парсит web_client_exec из bool или строки XML-атрибута. */
export function parseWebClientExecFlag(raw: unknown): boolean {
  if (typeof raw === 'boolean') {
    return raw
  }
  if (typeof raw === 'string') {
    return raw.trim().toLowerCase() === 'true'
  }
  return false
}

/** Определяет по атрибуту web_client_exec на ScriptData, выполнять ли скрипт на клиенте. */
export function getWebClientExecFromScriptNode(scriptData?: ScriptData): boolean {
  const attr = scriptData?._attributes
  const webClientExec = attr?.web_client_exec ?? false
  return parseWebClientExecFlag(webClientExec)
}

export function hasExplicitWebClientExecAttr(scriptData?: ScriptData): boolean {
  const a = scriptData?._attributes
  return (
    a != null &&
    typeof a === 'object' &&
    Object.prototype.hasOwnProperty.call(a, 'web_client_exec')
  )
}

/** Listener: web_client_exec=false — только middle; иначе клиент. */
export function shouldRunListenerOnClient(listener: { web_client_exec?: boolean }): boolean {
  return listener.web_client_exec !== false
}
